import React, { useEffect, useState } from "react";
import "./addTCAdminForm.scss";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { getTimezoneOption } from "../../globals/common_utilities/timezoneListing";
import InputTags from "../common/InputTags";
import Dropdown from "../../components/common/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import {
  isEmpty,
  validateEmail,
  validatePhone,
  validateName,
  validateScript,
  validateSkills,
} from "../../globals/common_utilities/utilities";
import {
  Redux_location,
  Redux_primary_aws,
  Redux_add_training_center,
} from "../../redux/forms";
import api_call from "../../globals/common_utilities/axios_old";
import download_icon from "../../Images/download_icon.svg";
import upload_icon from "../../Images/upload_icon.svg";
import { Box, Rating, Stack } from "@mui/material";
import * as XLSX from "xlsx";
import EDIT from "../../Images/formEdit.png";
import {
  API,
  FOMRS,
  STATUS,
  ROLE,
  APP_ROUTES,
} from "../../globals/constants/index";
import { Tooltip } from "@mui/material";
import Info from "../../Images/yellow_info_icon.svg";
import green_icon from "../../globals/assets/green_computer.svg";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import CLOSE from "../../Images/close.svg";
import _ from "lodash";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import Cookies from "universal-cookie";

const AddTCAdminForm = (props) => {
  const [showLoader, setShowLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [getTimeZoneList, setTimeZoneList] = useState();
  const [type, setType] = useState(state?.type || FOMRS.ADD);
  const [studioId, setSudioId] = useState(state?.id ? state?.id : "");
  const [instructorData, setInstructorData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [errorMessage, setErrorMessage] = useState();
  const [editCheckbox, setEditCheckbox] = useState(false);
  const [traininig_center_list, setTraining_center_list] = useState([]);
  const [admin_training_center, setAdmin_Training_Center] = useState();
  const [skills, setSkills] = useState([]);
  const [TcadminById, setTcAdminById] = useState("");

  const api_res = useSelector((state) => {
    return state.add_training_center.Response;
  });
  const { loginResponse } = useSelector((state) => {
    return state.login;
  });

  const [aws_region, setAws_region] = useState();
  const [location, setLocation_list] = useState();
  const [uploadFilterData, setUploadFilterData] = useState([]);

  console.log("api_res--------->>", api_res);
  //   Getting Token Values
  // const {
  // 	id,
  // 	name,
  // 	device_id,
  // 	studio_id,
  // 	role_id,
  // 	role_code,
  // 	token,
  // 	token_uniq_id,
  // 	email_id,
  // 	username,
  // 	is_email_verify,
  // } = loginResponse?.data;
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  console.log("Studio ID ", studio_id);
  console.log("Role Code ", role_code === "STUDIO_ADMIN");
  // Form Fields
  const [formField, setFormField] = useState({
    admin_name: "",
    username: "",
    Training_center_name: "",
    email_id: "",
    contact_no: "",
    location: "",
    skills: [],
    short_information: "",
  });
  // Error Fields
  const [formField_error, setFormFild_error] = useState({
    admin_name_error: false,
    username_error: false,
    Training_center_name_error: false,
    email_id_error: false,
    contact_no_error: false,
    location_error: false,
    skills_error: false,
    short_information_error: "",
  });
  //   TRAINING CENTER DROPDOWN API CALL
  const traininingCenterFun = async () => {
    console.log("Inside Fetching TRAINING CENTER FUN");
    if (role_code === ROLE.ADMIN) {
      const Response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.STUDIO_LIST
        }`,
        {
          is_active: true,
        }
      );
      if (Response.status === 200) {
        setTraining_center_list(
          Response.data?.data?.rows.map((value) => ({
            id: value.id,
            value: value.id,
            label: value.studio_name,
          }))
        );
      }
      console.log("Training Center Data Inside ", traininig_center_list);
    } else {
      console.log("Training Center Login Dropdown");
      const Response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.STUDIO_LIST
        }`,
        {
          is_active: true,
          studio_id: studio_id,
        }
      );
      console.log("Training Center Dropdown value ", Response.status === 200);
      if (Response.status === 200) {
        setTraining_center_list(
          Response.data?.data?.rows.map((value) => ({
            id: value.id,
            value: value.id,
            label: value.studio_name,
          }))
        );
        // setAdmin_Training_Center(training_center_fun[0].label)
        // console.log("Admin TC ",admin_training_center)
      }
    }
  };
  useEffect(() => {
    TimeZoneFun();
    traininingCenterFun();
    getLocationFun();
    if (type === FOMRS.VIEW || type === FOMRS.EDIT) {
      viewForm();
    }
  }, []);
  const toasterMsg = type === FOMRS.EDIT ? "updated" : "created";
  const getToster = (res) => {
    console.log("res?.status", res);
    if (res?.status === 200) {
      toast.success(`Training center admin ${toasterMsg} successfully`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      gotolistingPage();
    }
    if (res?.status === 409) {
      toast.error(res?.err?.data?.msg?.msg, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
    // console.log("Inside 409")
    // console.log(res.data.message)
    // console.log(res.data.message === 'Request failed with status code 409');
  };
  const viewForm = async () => {
    let params = { tc_id: studioId };
    setShowLoader(true);
    const { status, data } = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TC_BYID
      }`,
      params
    );
    console.log("Training Center Data : ", data);
    if (status === 200) {
      setShowLoader(false);
      // setTcAdminById(data)
      // console.log("Training Center List ",traininig_center_list)
      // console.log("Location List ",location)
      let trainingCenter = traininig_center_list
        ? traininig_center_list.filter(
            (item) => item?.id === data?.data?.["studio.id"]
          )
        : [];
      let locationData = location
        ? location.filter((item) => item.id === data?.data?.["location.id"])
        : [];
      // console.log("trainingCenter^^^^", trainingCenter)
      // console.log("locationData^^^^", locationData)

      setFormField({
        ...formField,
        admin_name: data?.data?.name,
        username: data?.data?.username,
        contact_no: data?.data?.contact_no,
        email_id: data?.data?.email_id,
        skills: data?.data?.skills ? JSON.parse(data?.data?.skills) : [],
        Training_center_name: trainingCenter[0],
        location: locationData[0],
        short_information: data?.data?.short_information,
      });
      console.log("View Form Fields : ", formField);
    } else {
      // setTraining_center_list([]);
    }
  };
  const TimeZoneFun = async () => {
    let timezone = await getTimezoneOption();
    setTimeZoneList(timezone);
  };
  // Location Dropdown API
  const getLocationFun = async () => {
    const Response = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_LOCATION
      }`
      // API.BASE_URL.STUDIO + API.END_POINTS.GET_LOCATION
    );
    if (Response.status === 200) {
      setLocation_list(
        Response.data?.data?.rows.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.code,
        }))
      );
    } else {
      setLocation_list([]);
    }
  };
  useEffect(() => {
    if (type === FOMRS.VIEW || type === FOMRS.EDIT) {
      viewForm();
    }
  }, [traininig_center_list, location]);

  const isValid = () => {
    console.log("Inside Validation");
    if (role_code === "STUDIO_ADMIN") {
      if (
        !isEmpty(formField.admin_name) &&
        formField.admin_name.trim().length !== 0 &&
        !isEmpty(formField.username) &&
        formField.username.trim().length !== 0 &&
        !isEmpty(formField.email_id) &&
        formField.email_id.trim().length !== 0 &&
        !isEmpty(formField.location) &&
        validateEmail(formField.email_id) &&
        validateScript(formField.username)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        !isEmpty(formField.admin_name) &&
        formField.admin_name.trim().length !== 0 &&
        !isEmpty(formField.username) &&
        formField.username.trim().length !== 0 &&
        !isEmpty(formField.email_id) &&
        formField.email_id.trim().length !== 0 &&
        !isEmpty(formField.location) &&
        !isEmpty(formField.Training_center_name) &&
        validateEmail(formField.email_id) &&
        validateScript(formField.username)
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  const onSubmit = async () => {
    console.log("Inside On Submit", isValid());
    console.log("Form Type - ", type);

    // console.log("training center ",formField.Training_center_name)
    // console.log("location list ",location)
    if (isValid()) {
      console.log("After Validation");
      // console.log('Skills : ', skills, 'Skills Length : ', skills.length);
      if (type === FOMRS.ADD) {
        console.log("Form Type - ", type);
        console.log("TC Studio ID ", traininig_center_list);

        // const { id }
        console.log("Training center ID ");
        let bodyParam = {
          name: formField.admin_name,
          studio_id:
            role_code === "STUDIO_ADMIN"
              ? studio_id
              : formField.Training_center_name.id,
          email_id: formField.email_id,
          location_id: formField.location?.id,
          skills: JSON.stringify(formField.skills),
          username: formField.username,
          tc_admin: true,
          is_active: true,
          createdBy: {
            id: id,
            name: name,
          },
        };
        console.log("Body Param : ", bodyParam, studio_id.id);
        let response = "";
        setShowLoader(true);
        response = await api_call(
          "POST",
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
            API.END_POINTS.ADD_TCADMIN,
          {},
          {},
          bodyParam
        );
        console.log("API Response : ", response);
        setShowLoader(false);
        getToster(response);
      } else {
        console.log("Form Type - ", type);
        console.log("Location ID ", formField.location.value);
        console.log("Studio ID ", formField.Training_center_name.value);

        let bodyParam = {
          name: formField.admin_name,
          studio_id: formField.Training_center_name.value,
          email_id: formField.email_id,
          location_id: formField.location.value,
          skills: JSON.stringify(formField.skills),
          username: formField.username,
          tc_admin: true,
        };
        console.log("Body Param Edit : ", bodyParam);
        let response = "";
        setShowLoader(true);
        response = await api_call(
          "PUT",
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
            `${API.END_POINTS.UPDATE_TCADMIN}?id=${studioId}`,
          {},
          {},
          bodyParam
        );
        console.log("API Response : ", response);
        setShowLoader(false);
        getToster(response);
      }
    } else {
      setFormFild_error(() => {
        return {
          ...formField_error,
          admin_name_error:
            isEmpty(formField.admin_name) ||
            formField.admin_name.trim().length === 0 ||
            !validateScript(formField.admin_name),
          username_error:
            isEmpty(formField.username) ||
            formField.username.trim().length === 0 ||
            !validateScript(formField.username),
          Training_center_name_error:
            isEmpty(formField.Training_center_name) ||
            !validateScript(formField.Training_center_name),
          email_id_error:
            isEmpty(formField.email_id) ||
            formField.email_id.trim().length === 0 ||
            !validateEmail(formField.email_id) ||
            !validateScript(formField.email_id),
          contact_no_error:
            isEmpty(formField.contact_no) ||
            formField.contact_no.trim().length === 0 ||
            !validatePhone(formField.contact_no) ||
            !validateScript(formField.contact_no),
          location_error:
            isEmpty(formField.location) || !validateScript(formField.location),
          // skills_error:
          //   formField.skills.length === 0 ||
          //   !validateScript(formField.skills) ||
          //   !validateSkills(formField.skills),
          short_information_error:
            isEmpty(formField.short_information) ||
            formField.short_information.trim().length === 0 ||
            !validateScript(formField.short_information),
        };
      });
    }
  };

  const timezone_fun = (e) => {
    let data1 = e.value.split("$");
    setFormField({ ...formField, time_zone: data1[0] });
    setFormFild_error({
      ...formField_error,
      time_zone_error: false,
    });
  };
  const location_fun = (e) => {
    console.log("location", e);
    setFormField({ ...formField, location: e });
    setFormFild_error({
      ...formField_error,
      location_error: false,
    });
  };
  const training_center_fun = (selected) => {
    // setFormField({ ...formField, Training_center_name: e.value });
    // setFormFild_error({
    //   ...formField_error,
    //   Training_center_name_error: false,
    // });
    setFormField({
      ...formField,
      Training_center_name: selected,
    });
    setFormFild_error({
      ...formField_error,
      Training_center_name_error: false,
    });
  };
  const gotolistingPage = (training) => {
    navigate(APP_ROUTES.ROUTE_TRAININGCENTER_ADMIN, {
      state: {},
    });
  };

  return (
    <>
      {console.log("formField----------->>", formField)}
      {console.log("formField----------->>", formField.skills.length)}
      <div className="mainContainer">
        {showLoader ? (
          <MultiLine_Spinner />
        ) : (
          <>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className="TitleContainer"
              container
              justifyContent={"space-between"}
            >
              <div>
                <span className="TitleName" onClick={gotolistingPage}>
                  {" "}
                  {`TC Admin >>`}{" "}
                </span>
                <span className="TrainingName">
                  {type === "ADD"
                    ? "Add "
                    : type === "EDIT"
                    ? "Edit "
                    : "View "}{" "}
                  TC Admin
                </span>
              </div>
            </Grid>
            <Grid
              container
              columnSpacing={2}
              rowSpacing={1.5}
              className="parentContainer"
            >
              <Stack
                width="100%"
                justifyContent={"flex-end"}
                alignItems="flex-end"
              >
                {type !== "ADD" && (
                  <div
                    className={
                      editCheckbox
                        ? "edit-add-center-form active_c"
                        : "edit-add-center-form"
                    }
                  >
                    <img
                      src={EDIT}
                      width="55px"
                      height="55px"
                      onClick={(e) => {
                        setEditCheckbox(!editCheckbox);
                        setType(editCheckbox ? "VIEW" : "EDIT");
                      }}
                    />
                  </div>
                )}
              </Stack>
              <Grid item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="formLabel"
                  >
                    Admin Name
                  </Grid>
                  <Grid item xs={11} sm={11} md={11} lg={11}>
                    <input
                      placeholder="Admin Name"
                      className="addTrainingInput"
                      value={formField?.admin_name}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          admin_name: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          admin_name_error: false,
                        });
                      }}
                    />
                    {formField_error.admin_name_error && (
                      <small className="error small_f">
                        Enter Admin Name *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This is the name of the admin of this training center. Example 'John Smith'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Username
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      placeholder="Username"
                      className="addTrainingInput"
                      value={formField?.username}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          username: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          username_error: false,
                        });
                      }}
                    />
                    {formField_error.username_error && (
                      <small className="error small_f">Enter Username *</small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This connects Cumulo to the Training Center Admin's Epic Games login. It's important to get this right. The admin can get their 'Display Name' from their Epic Games account. Please ask them to go to https://www.epicgames.com/account/personal to see their Display Name. Display Name is case sensitive "
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Email ID
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      className="addTrainingInput"
                      value={formField?.email_id}
                      disabled={type === FOMRS.VIEW}
                      placeholder="Email Address"
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          email_id: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          email_id_error: false,
                        });
                      }}
                    />
                    {formField_error.email_id_error && (
                      <small className="error small_f">
                        Enter Valid Email id *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        All communication regarding training activities concerning this training center will be sent to this email ID. Please ensure this is a valid email ID."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Contact no
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <input
                      placeholder="Contact No"
                      className="addTrainingInput"
                      value={formField?.contact_no}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          contact_no: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          contact_no_error: false,
                        });
                      }}
                    />
                    {formField_error.contact_no_error && (
                      <small className="error small_f">
                        Enter Valid contact no *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please provide the contact number of the Admin."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Training Center Name
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <Dropdown
                      className="dropDown"
                      value={
                        role_code === "STUDIO_ADMIN"
                          ? traininig_center_list
                          : formField.Training_center_name
                      }
                      isDisabled={
                        type === FOMRS.VIEW || role_code === "STUDIO_ADMIN"
                      }
                      clearable
                      options={traininig_center_list}
                      onChange={(selected) => training_center_fun(selected)}
                      selection
                      placeholder="Training Center Name"
                    />
                    {role_code === "STUDIO_ADMIN"
                      ? null
                      : formField_error.Training_center_name_error && (
                          <small className="error small_f">
                            Please select training center Name *
                          </small>
                        )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please select the Training center for which this person would be an Admin. Eg 'John Smith Training and Edu'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Location
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <Dropdown
                      className="dropDown"
                      value={formField?.location}
                      isDisabled={type === FOMRS.VIEW}
                      clearable
                      options={location}
                      onChange={(e) => location_fun(e)}
                      selection
                      placeholder="Select location"
                    />
                    {formField_error.location_error && (
                      <small className="error small_f">
                        Select Valid location *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Select the nearest region to your training center's location. This is only for self-reference and tagging purposes."
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid Item xs={12} sm={12} md={6} lg={6} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Skills
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <InputTags
                      className="dropDown"
                      placeholder="Add skills (eg: Gaming) &amp; hit enter"
                      readOnly={type === FOMRS.VIEW}
                      tags={formField?.skills}
                      // editable={this.state.actionOnpage === CONSTANTS.ACTION.EDIT}
                      removeOnBackspace={true}
                      onChange={(val) => {
                        // console.log('Form Type : ', type);
                        console.log("Skills Val ", val);
                        setFormField({ ...formField, skills: val });
                        setFormFild_error({
                          ...formField_error,
                          skills_error: false,
                        });
                      }}
                    />
                    {formField_error.skills_error && (
                      <small className="error small_f">
                        Enter Valid Skills *
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        This tags what this training center is most skilled in teaching. Eg: If this training center primarily teaches game development, then add 'games' as the tag. You can add multiple tags. This is purely for self-reference purposes"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid> */}
              {/* <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                    Short Information
                  </Grid>
                  <Grid xs={11} sm={11} md={11} lg={11}>
                    <textarea
                      rows={3}
                      placeholder="Short Information"
                      className="addTrainingTextarea"
                      value={formField?.short_information}
                      disabled={type === FOMRS.VIEW}
                      onChange={(e) => {
                        setFormField({
                          ...formField,
                          short_information: e.target.value,
                        });
                        setFormFild_error({
                          ...formField_error,
                          short_information_error: false,
                        });
                      }}
                    />
                    {formField_error.short_information_error && (
                      <small className="error small_f">
                        Please enter detail about tc admin*
                      </small>
                    )}
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <div className="info_image">
                      <Tooltip
                        title="
                        Please provide a brief info about the Training Center. Eg: 'John Smith Training and Edu have 3 UAIs. They are premium studio with over 8 years of teaching experience'"
                        placement="top-start"
                        arrow
                      >
                        <img src={Info} className="tooltip-align" />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid Item xs={12} sm={12} md={12} lg={12} className="fieldDiv">
                <Grid xs={12} sm={12} md={12} lg={12} className="formLabel">
                  {type === "ADD" && (
                    <button className="AddCentreButton" onClick={onSubmit}>
                      Add TC Admin
                    </button>
                  )}
                  {type === "EDIT" && (
                    <button className="AddCentreButton" onClick={onSubmit}>
                      Update TC Admin
                    </button>
                  )}
                  {type === FOMRS.VIEW ? (
                    ""
                  ) : (
                    <button className="cancelButton" onClick={gotolistingPage}>
                      Cancel
                    </button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default AddTCAdminForm;
